module.exports = {"data":{"site":{"siteMetadata":{"title":"Bristol Chiropractor","contactDetails":{"address":["50 Kenmore Cresent","Filton Park","Bristol","BS7 0TR"],"telephoneNumber":"07908 649609","emailAddress":"ian@bristolchiropractor.co.uk","socialMedia":{"twitter":"@backsgetbetter","facebook":"https://fb.me/bristolchiropractor"}}}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 109
// module chunks = 60335399758886 114276838955818